"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnLoadClient = void 0;
const src_1 = require("..");
function braintreeOnLoadClient() {
    if (window.braintree) {
        (0, src_1.setBraintreeClient)(window.braintree);
    }
}
exports.braintreeOnLoadClient = braintreeOnLoadClient;
